import React from 'react';
import { Box } from '@mui/material';

export default function Image({ image }) {
  return (
    <Box mb={1} ml={1}>
      {typeof image === 'string' ? (
        <img src={image} alt="Page Title" style={{ maxWidth: '70%' }} />
      ) : (
        image 
      )}
    </Box>
  );
}
